export default {
	checkEmail: "Check your Email",
	checkSpam: "Can't find it? Check your spam folder.",
	error: "Verification Error",
	goToLogin: "Go to Login",
	invalidToken: "Invalid or expired token. Please request a new one.",
	resend: "Resend Email",
	resendSuccess: "Email resent successfully!",
	sentTo: "We sent a verification link to {email}",
	success: "Email Verified!",
	successDesc: "Your account has been activated successfully. You can now log in.",
	verifying: "Verifying...",
};
